// This icon file is generated automatically.
var PtoArrRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M23.93 15.21l-14.09-11a.25.25 0 00-.4.2v2.41c0 .15.07.3.19.4L20.88 16 9.63 24.78a.5.5 0 00-.2.4v2.41c0 .21.25.33.41.2l14.09-11a1 1 0 000-1.58z", "fill-rule": "nonzero" } }] }, "name": "pto-arr-right", "theme": "outlined" };
export default PtoArrRightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoArrRightOutlined.js
// module id = 3872
// module chunks = 0